import {selectUserProfile} from '../selectors'
import {createSelector} from 'reselect'
import {userComparator} from '../../usersSelector/user_group_selector_util'

export const selectTeamList = (state) => selectUserProfile(state).teamList

export const isLoading = (state) => selectTeamList(state).loading

export const isNeedToLoadData = (state) => selectTeamList(state).needToLoadData

export const getTeamNames = (state) => selectTeamList(state).teamNames

export const getSortedTeamUsers = createSelector(
    getTeamNames,
    (teamUsers) => {
        return teamUsers.sort(userComparator)
    }
)



// WEBPACK FOOTER //
// ./web/js/userProfile/assignedTeamList/selectors.js